import { useFrontendVersion } from "@/hooks/use-frontend-version";
import { forwardRef } from "react";
import type { LinkProps } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";

export const Link = forwardRef<HTMLAnchorElement, LinkProps & { reloadIfFrontendUpdated?: boolean }>(
    ({ reloadIfFrontendUpdated, ...props }, ref) => {
        const { isFrontendUpdated } = useFrontendVersion();

        const reloadDocument = reloadIfFrontendUpdated && isFrontendUpdated;
        const extras = reloadDocument ? { reloadDocument: true, "data-test-reload-document": { reloadDocument } } : {};
        return <RouterLink {...props} ref={ref} {...extras} />;
    },
);
Link.displayName = "Link";
